class TcrMouseHandler
{
    primary = undefined;
    secondary = undefined;

    x = 0;
    y = 0;

    timer = 0;
    done = false;

    constructor(primary, secondary)
    {
        this.primary = primary;
        this.secondary = secondary;

        this.down = this.down.bind(this);
        this.up = this.up.bind(this);
        this.cancel = this.cancel.bind(this);
        this.move = this.move.bind(this);

        this.props = {
            onmousedown: this.down,
            oncontextmenu: this.none,
            onmouseup: this.up,
            onmouseleave: this.cancel,
            onmouseout: this.cancel,
            ontouchstart: this.down,
            ontouchend: this.up,
            ontouchcancel: this.cancel,
            ontouchmove: this.move
        };
    }

    none(e)
    {
        e.preventDefault();
    }

    down(e)
    {
        e.preventDefault();
        this.done = false;
        this.x = e.pageX;
        this.y = e.pageY;
        this.timer = setTimeout(() =>
        {
            if (!this.done)
            {
                //console.log('time');
                //console.log('secondary, timeout');
                //if timeout reached, fire the secondary event
                if (this.secondary) this.secondary(e);
                this.timer = 0;
                this.done = true;
            }
        }, 500);
    }

    up(e)
    {
        e.preventDefault();
        if (!this.done && this.timer > 0)
        {
            //console.log('up', e);
            clearTimeout(this.timer);
            this.timer = 0;
            this.done = true;
            //fire primary or secondary based on button
            if (e.button == 2)
            {
                //console.log('secondary');
                if (this.secondary) this.secondary(e);
            }
            else
            {
                //console.log('primary');
                if (this.primary) this.primary(e);
            }
        }
    }

    cancel(e)
    {
        //console.log('cancel');
        if (!this.done)
        {
            this.done = true;
            clearTimeout(this.timer);
            this.timer = 0;
        }
    }

    move(e)
    {
        if (!this.done && e.type == 'touchmove' && (Math.abs(e.pageX - this.x) > 15 || Math.abs(e.pageY - this.y) > 15))
        {
            this.done = true;
            clearTimeout(this.timer);
            this.timer = 0;
        }
    }
}

export { TcrMouseHandler };